export default __webpack_public_path__ + "static/media/submission.cf9b4037.png";